<template>
  <img :src="badgeImage" alt="" />
</template>

<script setup lang="ts">
import BadgePlanPro from '@/assets/images/badge-plan-pro.png'
import BadgePlanLight from '@/assets/images/badge-plan-light.png'
import BadgePlanTeam from '@/assets/images/badge-plan-light.png'
import { computed } from 'vue'

const props = defineProps<{
  group: 'light' | 'pro' | 'team'
}>()

const badgeImage = computed(() => {
  const lowercaseGroup = props.group.toLowerCase()
  if (lowercaseGroup === 'pro') return BadgePlanPro
  if (lowercaseGroup === 'light') return BadgePlanLight
  return BadgePlanTeam
})
</script>
